import tableAuditChange from './tableAuditChange';

export default {
  title: 'Changes',
  attributeName: 'change',
  getURL: 'audit/uuid/change',
  itemName: 'change',
  itemId: 'uuid',
  sessionParams: ['uuid'],
  tableConfig: tableAuditChange,
};
